module.exports = __webpack_public_path__ + "static/media/caravan.65be4ddc.svg";